<template>
  <div class="hoory-spinner-container">
    <div :class="`${size} hoory-spinner`" v-html="spinnerSvg" />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    color: {
      type: String,
      default: '#623bea',
    },
  },
  data() {
    return {
      spinnerSvg: `<svg id="eV6XWCjUl121" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 888.02 329.77" shape-rendering="geometricPrecision"
            text-rendering="geometricPrecision">
            <style><![CDATA[
        #eV6XWCjUl123_ts {animation: eV6XWCjUl123_ts__ts 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl123_ts__ts { 0% {transform: translate(444.009995px,164.889992px) scale(1,1)} 16.666667% {transform: translate(444.009995px,164.889992px) scale(1,1)} 17% {transform: translate(444.009995px,164.889992px) scale(1,1);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 30.333333% {transform: translate(444.009995px,164.889992px) scale(1.2,1.2)} 43.666667% {transform: translate(444.009995px,164.889992px) scale(1,1)} 100% {transform: translate(444.009995px,164.889992px) scale(1,1)}} #eV6XWCjUl123 {animation: eV6XWCjUl123_c_o 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl123_c_o { 0% {opacity: 1} 66.666667% {opacity: 1} 70% {opacity: 0} 100% {opacity: 0}} #eV6XWCjUl124_to {animation: eV6XWCjUl124_to__to 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl124_to__to { 0% {transform: translate(106.980003px,164.889992px)} 56.666667% {transform: translate(106.980003px,164.889992px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 70% {transform: translate(444.010003px,164.889992px)} 100% {transform: translate(444.010003px,164.889992px)}} #eV6XWCjUl124_ts {animation: eV6XWCjUl124_ts__ts 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl124_ts__ts { 0% {transform: scale(1,1)} 3.333333% {transform: scale(1,1);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 16.666667% {transform: scale(1.2,1.2)} 30% {transform: scale(1,1)} 100% {transform: scale(1,1)}} #eV6XWCjUl124 {animation: eV6XWCjUl124_c_o 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl124_c_o { 0% {opacity: 1} 66.666667% {opacity: 1} 70% {opacity: 0} 100% {opacity: 0}} #eV6XWCjUl125_to {animation: eV6XWCjUl125_to__to 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl125_to__to { 0% {transform: translate(781.040009px,164.889992px)} 56.666667% {transform: translate(781.040009px,164.889992px);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 70% {transform: translate(444.010009px,164.889992px)} 100% {transform: translate(444.010009px,164.889992px)}} #eV6XWCjUl125_ts {animation: eV6XWCjUl125_ts__ts 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl125_ts__ts { 0% {transform: scale(1,1)} 30.333333% {transform: scale(1,1);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 43.666667% {transform: scale(1.2,1.2)} 57% {transform: scale(1,1)} 100% {transform: scale(1,1)}} #eV6XWCjUl125 {animation: eV6XWCjUl125_c_o 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl125_c_o { 0% {opacity: 1} 66.666667% {opacity: 1} 70% {opacity: 0} 100% {opacity: 0}} #eV6XWCjUl126_ts {animation: eV6XWCjUl126_ts__ts 3000ms linear infinite normal forwards}@keyframes eV6XWCjUl126_ts__ts { 0% {transform: translate(444.01px,164.88501px) scale(0,0)} 56.666667% {transform: translate(444.01px,164.88501px) scale(0,0);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 76.666667% {transform: translate(444.01px,164.88501px) scale(0.8,0.8);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 93.333333% {transform: translate(444.01px,164.88501px) scale(0.762232,0.762235)} 100% {transform: translate(444.01px,164.88501px) scale(0.762232,0.762235)}}
        ]]></style>
            <g transform="matrix(.762232 0 0 0.762235 105.571372 39.205069)">
                <g id="eV6XWCjUl123_ts" transform="translate(444.009995,164.889992) scale(1,1)">
                    <circle id="eV6XWCjUl123" r="106.98" transform="translate(0.000005,0.000008)"
                        fill="${this.color}" />
                </g>
                <g id="eV6XWCjUl124_to" transform="translate(106.980003,164.889992)">
                    <g id="eV6XWCjUl124_ts" transform="scale(1,1)">
                        <circle id="eV6XWCjUl124" r="106.98" transform="translate(-0.000003,0.000008)"
                            fill="${this.color}" />
                    </g>
                </g>
                <g id="eV6XWCjUl125_to" transform="translate(781.040009,164.889992)">
                    <g id="eV6XWCjUl125_ts" transform="scale(1,1)">
                        <circle id="eV6XWCjUl125" r="106.98" transform="translate(-0.000009,0.000008)"
                            fill="${this.color}" />
                    </g>
                </g>
            </g>
            <g id="eV6XWCjUl126_ts" transform="translate(444.01,164.88501) scale(0,0)">
                <g transform="translate(-444.005005,-164.88501)">
                    <path
                        d="M558.74,46.63c-2.6-2.52-5.27-4.95-8.03-7.3C521.93,14.83,484.68,0,444,0s-77.92,14.83-106.7,39.33c-2.76,2.35-5.43,4.78-8.03,7.3-2.64,2.56-5.21,5.19-7.67,7.92-26.39,29.24-42.48,67.95-42.48,110.34c0,12.71,1.49,25.07,4.23,36.96.82,3.57,1.74,7.11,2.79,10.59c1.06,3.51,2.23,6.97,3.51,10.38C313.16,285.24,373.46,329.77,444,329.77s130.85-44.54,154.36-106.95c1.28-3.41,2.46-6.87,3.52-10.38c1.05-3.48,1.97-7.02,2.79-10.59c2.73-11.89,4.23-24.25,4.23-36.96c0-42.4-16.1-81.1-42.48-110.34-2.46-2.73-5.03-5.36-7.67-7.92h-.01ZM416.57,180.42c-2.8,6.05-6.81,10.77-12.01,14.18s-11.41,5.12-18.62,5.12-13.31-1.71-18.62-5.12c-2.27-1.49-4.27-3.27-6.08-5.26-2.34-2.57-4.35-5.51-5.93-8.92c0,0,0,0,0,0-1.75-3.83-2.89-8.11-3.54-12.75-.39-2.78-.66-5.67-.66-8.74c0-8.28,1.39-15.44,4.2-21.49c2.36-5.09,5.63-9.16,9.69-12.31.76-.59,1.5-1.2,2.31-1.72c2.45-1.53,5.12-2.67,7.96-3.49c3.22-.93,6.67-1.44,10.37-1.46.1,0,.19-.02.29-.02c7.21,0,13.42,1.66,18.62,4.97s9.21,7.99,12.01,14.03c2.8,6.05,4.21,13.21,4.21,21.49-.01,8.19-1.41,15.36-4.21,21.49h.01Zm119.67-12.77c-.66,4.64-1.79,8.92-3.54,12.75c0,0,0,0,0,.01-1.58,3.41-3.58,6.34-5.92,8.91-1.81,1.99-3.82,3.78-6.09,5.27-5.2,3.41-11.41,5.12-18.62,5.12s-13.31-1.71-18.62-5.12c-5.2-3.41-9.21-8.13-12.01-14.18-2.8-6.13-4.2-13.3-4.2-21.49s1.39-15.44,4.2-21.49c2.8-6.05,6.81-10.72,12.01-14.03c5.31-3.31,11.51-4.97,18.62-4.97.11,0,.2.02.31.02c3.73.03,7.18.52,10.37,1.44c2.86.83,5.52,1.97,7.94,3.51.83.53,1.57,1.14,2.33,1.74c4.06,3.15,7.32,7.21,9.68,12.29c2.8,6.05,4.21,13.21,4.21,21.49c0,3.07-.27,5.94-.66,8.72l-.01.01Z"
                        fill="${this.color}" />
                    <path
                        d="M605.86,40.46c-9.1,0-17.2,1.01-25.29,4.05c28.32,32.37,45.52,73.85,45.52,120.38c0,15.17-2.02,29.34-5.06,42.49c39.45-7.08,68.79-41.47,68.79-82.95c0-46.53-37.43-83.96-83.96-83.96v-.01Z"
                        fill="${this.color}" />
                    <path
                        d="M307.44,44.51c-8.09-3.03-16.18-4.05-25.29-4.05-46.53,0-83.96,37.43-83.96,83.96c0,41.48,29.34,75.87,68.79,82.95-3.03-14.16-5.06-28.32-5.06-42.49c0-46.53,17.2-88.01,45.52-120.38v.01Z"
                        fill="${this.color}" />
                </g>
            </g>
        </svg>`,
    };
  },
};
</script>

<style scoped lang="scss">
.hoory-spinner-container {
  width: 100%;
  height: fit-content;
  min-height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.hoory-spinner {
  display: flex;
  &.full {
    width: 100%;
  }
  &.tiny {
    width: var(--space-semilarge);
    height: var(--space-semilarge);
  }
  &.small {
    width: var(--space-larger);
    height: var(--space-larger);
  }
  &.normal {
    width: var(--space-jumbo);
    height: var(--space-jumbo);
  }
  &.medium {
    width: var(--space-mega);
    height: var(--space-mega);
  }
  &.large {
    width: var(--space-giga);
    height: var(--space-giga);
  }
}
</style>
